/**
 * Print button function
 *
 * This class handles the click of the Print button.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class ContentPrint. This gets mapped with the keyword contentprint and its
 * docready method is fired automatically on pages where there's a
 * class called 'ContentPrint' on the html tag.
 */
class ContentPage {

    /**
     * The class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the methods
     */
    cache() {
        this.printButton = $( '#js-print-button' );

        // Get thead td for assigning scope col
        this.tableHead = $( 'thead tr td' );
    };

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Function to make the print button open the print prompt
        this.printButton.on( 'click', e => {
            window.print();
        });
    }

    /**
     * Move table heads to each cell to allow print friendly cards
     */

     tableToCards() {

        const tables = $( 'table' );

        tables.each( function( index, table ) {
            const headColCount =  $( table ).find( 'thead tr td' ).length;
            let j;

            for ( j = 0; j <= headColCount; j++ ) {

                const headColLabel = $( table ).find( 'thead td:nth-child( ' + j + ' )' ).text();

                $( table ).find( 'tr td:nth-child( ' + j + ' )' ).attr( 'data-title', headColLabel );
            }
        });
     }


     /**
      * Hide Cookie disclaimer if closed before
      */
    tableScope() {
        this.tableHead.attr( 'scope', 'col' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.tableToCards();
        this.tableScope();
    }
}

// Export the class reference.
module.exports = ContentPage;



// WEBPACK FOOTER //
// ./assets/scripts/contentpage.js